import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Point } from "../../shared/data.service";
import { GroupPointsInsertRequest } from "../../shared/GroupPointsInsertRequest";
import { PointTransactionInfo, PointTransactionRequest } from "../../shared/PointTransactionRequest";

@Component({
	selector: "app-group-redeem-point",
	templateUrl: "./group-redeem-point.component.html",
	styleUrls: ["./group-redeem-point.component.css"],
})
export class GroupRedeemPointComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_Point,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SchoolName = this.dialogConfig.data.SchoolName;
		this.GroupID = this.dialogConfig.data.GroupID;
		this.GroupName = this.dialogConfig.data.GroupName;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	user: any;
	GroupID: any;
	GroupName: any;

	SchoolID: any;
	SchoolName: any;

	SelectedPoint: any;
	lstPoints: any = [];
	ItemLoading: any = true;
	Processing: any = false;

	errorMessage: any = "";

	AddStudentPrompt: boolean = false;

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////
	loadPointItem() {
		this.ItemLoading = true;

		var result = this.PBISService.PBISPointItemSelectList(2, this.SchoolID); //2 for Academic? / Redeem?
		result.subscribe(
			(response) => {
				this.lstPoints = response;

				this.SelectedPoint = this.lstPoints[0];

				this.ItemLoading = false;
			},
			(error) => {
				this.ItemLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		if (this.lstPoints.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "redeemgroupwarning",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				'NOTE: this will redeem points for all of the students assigned to "' +
				this.GroupName +
				"\". This might cause some students to have a negative balance if they haven't received enough points for the transaction. Do you want to continue?",
			header: "Confirm Redeem Points",
			icon: "fa",
			accept: () => {
				this.FinishAdd();
			},
		});
	}

	FinishAdd() {
		this.Processing = true;

		//
		// Create Request
		//

		let parms: GroupPointsInsertRequest = {
			GroupID: this.GroupID,
			PointsTransactionTypeID: 2, // 2 = Redeemed Point
			PointsItemID: this.SelectedPoint.PointsItemID,
			PointsItemValue: this.SelectedPoint.PointsItemValue,
			IsVoid: 0,
			c_PersonID: this.user.personID,
			AddStudentPrompt: this.AddStudentPrompt == true ? 0 : 1,
		};

		//
		// Call SP
		//

		var result = this.PBISService.GroupPointsInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "redeemgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was redeemed successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "redeemgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not redeem the point: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////

	onPointChange(val) {
		this.SelectedPoint = val;

		this.errorMessage = "";
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.ItemLoading || this.Processing;
	}

	//////////////////////////////////////////////////////////////////
}
